/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-09-11 14:38:23
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description: 获取区县列表
 * @param {
 * }
 * @return {*}
 */
export const findCountyList = (data) => {
    return axios.request({
        url: `${API_MAIN}/findCountyList`,
        method: 'post',
        data
    })
}

/**
 * @description: 获取区县下学校列表
 * @param {
* }
* @return {*}
*/
export const findSchPage = (data) => {
   return axios.request({
       url: `${API_MAIN}/findSchPage`,
       method: 'post',
       data
   })
}

/**
 * @description: 获取全部类别
 * @param {
* }
* @return {*}
*/
export const findGwCaseSortList = (data) => {
   return axios.request({
       url: `${API_MAIN}/findGwCaseSortList`,
       method: 'post',
       data
   })
}

/**
 * @description: 案例分页（已审核）
 * @param {
* }
* @return {*}
*/
export const findGwCheckedCasePage = (data) => {
   return axios.request({
       url: `${API_MAIN}/findGwCheckedCasePage`,
       method: 'post',
       data
   })
}
/**
 * @description: 案例详情
 * @param {
* }
* @return {*}
*/
export const findGwCaseDetail = (data) => {
   return axios.request({
       url: `${API_MAIN}/findGwCaseDetail`,
       method: 'post',
       data
   })
}








// WEBPACK FOOTER //
// ./src/api/case.js